import { render, staticRenderFns } from "./VehicleLeft.vue?vue&type=template&id=0510204b&"
import script from "./VehicleLeft.vue?vue&type=script&lang=js&"
export * from "./VehicleLeft.vue?vue&type=script&lang=js&"
import style0 from "./VehicleLeft.vue?vue&type=style&index=0&id=0510204b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports